import type {ComponentWithAs} from '@chakra-ui/react';
import {Circle, forwardRef, HStack, StackItem, Text, useStyleConfig, VStack} from '@chakra-ui/react';
import type {ComponentType, FC, PropsWithRef} from 'react';
import type {Payload} from 'recharts/types/component/DefaultTooltipContent';
import type {DefaultTooltipContentProps} from 'recharts';

import {Time} from '../Time';

import {toSentenceCase} from './ChartLegend';

type Props = DefaultTooltipContentProps<any, any> & {
  filter?: (payload: Payload<any, any>) => boolean;
  external?: boolean;
};

const ChartTooltip: FC<PropsWithRef<Props>> = forwardRef<Props, ComponentType<ComponentWithAs<'div'>>>(
  ({payload, label, filter}, ref) => {
    const style = useStyleConfig(`Tooltip`);
    if (!payload?.length) {
      return null;
    }

    const filteredPayload = filter ? payload?.filter(filter) : payload?.filter(p => !`${p?.dataKey}`?.includes(`gap`));
    return (
      <VStack ref={ref} sx={style} alignItems={`start`}>
        <StackItem>
          <Text color={`text.inverse`}>
            <Time fontSize={`inherit`} date={label} format={`do, MMMM`} />
          </Text>
        </StackItem>
        {filteredPayload?.map((entry, index) => (
          <StackItem display={`flex`} flexDirection={`column`} justifyContent={`center`} alignItems={`start`}>
            <HStack alignItems={`center`} key={`legend-${index}`} spacing={`8`}>
              <Circle background={entry.color} size={`2`} />
              <Text color={`text.inverse`}>{toSentenceCase(entry.name)}</Text>
            </HStack>
          </StackItem>
        ))}
      </VStack>
    );
  },
);

export default ChartTooltip;
